module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qskel4-82fd3d5287e5c9d60b205506177fd70b.jpg";